<template>
  <div class="offer-card">
    <div class="offer-image-container">
  <img :src="getImageSrc(offer)" :alt="offer.title" class="offer-image" />
    </div>
    <div class="offer-content">
      <h3 class="offer-title">{{ offer.title }}</h3>
      <p class="offer-description">{{ offer.description }}</p>
      <!-- Or a router-link if it's an internal page -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import defaultPlaceholder from '@/assets/placeholder/salon-hero.jpg'; // A generic placeholder

export interface Offer {
  id: string | number;
  title: string;
  description: string;
  imageName?: string; // Optional (local placeholder)
  imageUrl?: string; // Optional external/Cloudinary URL
  linkUrl?: string; // Optional link for the offer.
}

export default defineComponent({
  name: 'OfferCard',
  props: {
    offer: {
      type: Object as PropType<Offer>,
      required: true,
    },
  },
  setup() {
      const getImageSrc = (offer: Offer) => {
        if (offer.imageUrl && offer.imageUrl.trim() !== '') {
          return offer.imageUrl;
        }
        return defaultPlaceholder;
      };

      return {
        getImageSrc,
      };
  },
});
</script>

<style scoped>
.offer-card {
  background-color: var(--background-light, #fff);
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.07);
  overflow: hidden;
  text-align: left;
  display: flex;
  flex-direction: column;
  width: 300px; /* Fixed width for carousel items, adjust as needed */
  flex-shrink: 0; /* Prevent shrinking in flex container */
  margin-right: 20px; /* Space between cards */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.offer-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.offer-card:last-child {
  margin-right: 0;
}

.offer-image-container {
  width: 100%;
  height: 180px; /* Adjust height as needed for offer images */
  overflow: hidden;
  background-color: #eee; /* Placeholder bg if image is missing */
}

.offer-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}
.offer-card:hover .offer-image {
  transform: scale(1.03);
}

.offer-content {
  padding: 20px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.offer-title {
  font-size: 1.4em;
  color: var(--brand-gold);
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: 600;
}

.offer-description {
  font-size: 0.95em;
  color: var(--text-dark);
  line-height: 1.6;
  margin-bottom: 15px;
  flex-grow: 1; /* Allows description to take available space */
}

.btn-small {
  padding: 8px 15px;
  font-size: 0.9em;
  align-self: flex-start; /* Align button to the start of the flex container */
}
</style>